import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import GroupsCard from './GroupsCard';

import './Groups.css';

@inject('translationsStore', 'fleetCustomerContractsStore', 'filterStore')
@observer
export default class Groups extends Component {
  componentDidMount = () => {
    const { filterStore } = this.props;
    filterStore.addToMonitoring('groupFilter.all');
    filterStore.addToMonitoring('groupFilter.tobeconnected');
    filterStore.addToMonitoring('groupFilter.connected');
    filterStore.addToMonitoring('groupFilter.tobedisconnected');
    filterStore.addToMonitoring('groupFilter.disconnected');
  };

  selectAll = () => {
    this.props.onSelect({ selected: 'all' });
    this.props.onGroupChange();
  };

  selectToBeConnected = () => {
    this.props.onSelect({ selected: 'tobeconnected' });
    this.props.onGroupChange('tobeconnected');
  };

  selectConnected = () => {
    this.props.onSelect({ selected: 'connected' });
    this.props.onGroupChange('connected');
  };

  selectToBeDisconnected = () => {
    this.props.onSelect({ selected: 'tobedisconnected' });
    this.props.onGroupChange('tobedisconnected');
  };

  selectDisconnected = () => {
    this.props.onSelect({ selected: 'disconnected' });
    this.props.onGroupChange('disconnected');
  };

  render() {
    const { translationsStore, fleetCustomerContractsStore } = this.props;

    return (
      <div className="Groups">
        <GroupsCard
          name="all"
          title={translationsStore.translate('vehiclesManager.groups.aggregatedAllVehicles')}
          description={fleetCustomerContractsStore.groupsLength('groupFilter', 'all')}
          selected={this.props.selected === 'all'}
          onClick={this.selectAll}
        />
        <GroupsCard
          name="tobeconnected"
          title={translationsStore.translate('vehiclesManager.groups.aggregatedToBeConnectedVehicles')}
          description={fleetCustomerContractsStore.groupsLength('groupFilter', 'tobeconnected')}
          selected={this.props.selected === 'tobeconnected'}
          onClick={this.selectToBeConnected}
          theme="alternative"
        />
        <GroupsCard
          name="connected"
          title={translationsStore.translate('vehiclesManager.groups.aggregatedConnectedVehicles')}
          description={fleetCustomerContractsStore.groupsLength('groupFilter', 'connected')}
          selected={this.props.selected === 'connected'}
          onClick={this.selectConnected}
          theme="alternative"
        />
        <GroupsCard
          name="tobedisconnected"
          title={translationsStore.translate('vehiclesManager.groups.aggregatedToBeDisconnectedVehicles')}
          description={fleetCustomerContractsStore.groupsLength('groupFilter', 'tobedisconnected')}
          selected={this.props.selected === 'tobedisconnected'}
          onClick={this.selectToBeDisconnected}
          theme="alternative"
        />
        <GroupsCard
          name="disconnected"
          title={translationsStore.translate('vehiclesManager.groups.aggregatedDisconnectedVehicles')}
          description={fleetCustomerContractsStore.groupsLength('groupFilter', 'disconnected')}
          selected={this.props.selected === 'disconnected'}
          onClick={this.selectDisconnected}
          theme="alternative"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/SelectableVehicles/Groups/Groups.js